import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChat = () => {
  return (
    <g>
      <path d="m14.6372 4.3755h-2.958v-1.8008a1.2139 1.2139 0 0 0 -1.2041-1.2207h-9.1094a1.216 1.216 0 0 0 -1.208 1.2207v6.0908a1.2181 1.2181 0 0 0 1.208 1.2245h.916l.002 1.0381a.7.7 0 0 0 1.2256.46l.8125-.924v1.2249a1.2139 1.2139 0 0 0 1.2041 1.221h5.6494l1.3184 1.498a.7.7 0 0 0 1.2256-.4619v-1.0361h.918a1.2148 1.2148 0 0 0 1.2051-1.2207v-6.0931a1.2147 1.2147 0 0 0 -1.2052-1.2207zm-10.6523 4.3525-.3125.3555a.7011.7011 0 0 0 -.6924-.5935h-1.4219v-5.7356h8.7207v1.6211h-4.7529a1.2139 1.2139 0 0 0 -1.2041 1.2207v2.9343a.6865.6865 0 0 0 -.3369.1975zm10.457 2.7812h-1.4219a.7.7 0 0 0 -.6914.5918l-.3115-.3535a.6991.6991 0 0 0 -.5254-.2383h-5.77v-5.7333h8.72z" />
    </g>
  );
};

export default withIcon(IconChat);
